import NavInfoTile from './NavInfoTile'

export default NavInfoTile
